import { useState } from 'react';
import { Typography, Popover, TextField, Box, IconButton } from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';
import { formatTime, parseTime } from '@utils/time/timeUtils';

export default function TimeClockEditor() {
  const { currentTime, duration, seekTo, currentEpisode } = useAudioPlayer();
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputValue, setInputValue] = useState('');

  const handleClick = (event) => {
    if (!currentEpisode) return;
    setInputValue(formatTime(currentTime));
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubmit = () => {
    const newTime = parseTime(inputValue);
    if (newTime >= 0 && newTime <= duration) {
      seekTo(newTime);
    }
    handleClose();
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleTimeKeyDown = (event) => {
    if (currentEpisode && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      handleClick(event);
    }
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Typography
        variant="caption"
        onClick={handleClick}
        onKeyDown={handleTimeKeyDown}
        role="button"
        tabIndex={currentEpisode ? 0 : -1}
        aria-label="Edit playback time"
        sx={{
          cursor: currentEpisode ? 'pointer' : 'default',
          userSelect: 'none',
          color: currentEpisode ? 'text.primary' : 'text.disabled',
          '&:hover': currentEpisode ? {
            textDecoration: 'underline'
          } : {}
        }}
      >
        {formatTime(currentTime)}
      </Typography>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextField
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="MM:SS"
            size="small"
            autoFocus
            sx={{ width: 100 }}
          />
          <IconButton size="small" color="primary" onClick={handleSubmit}>
            <Check />
          </IconButton>
          <IconButton size="small" onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
      </Popover>
    </>
  );
}
